export default {
  // Vino
  Filtro_Fasi_Vino: 'Fases',
  Filtro_Soluzioni_Vino: 'Soluciones',
  Filtro_Tipologia_Vino: 'Tipo de vino',
  Filtro_Certificazioni_Vino: 'Certificaciones',
  Filtro_Tipologia_Prodotto_Vino: 'Tipo de Producto',
  // Cerveza
  Filtro_Stili_Birra: 'Estilos',
  Filtro_Fermentazione_Birra: 'Fermentación',

  // Fases
  Fermentazione: 'Fermentación',
  Affinamento: 'Afinamiento',
  Chiarifica: 'Clarificación',
  Finissaggio: 'Acabado',
  Spumantizzazione: 'Espumantización',
  'In vigna': 'En la Viña',
  'Mosto/Pigiatura': 'Mosto/Estrujado',
  Stabilizzazione: 'Estabilización',
  Uva: 'Uva',

  // Soluciones
  'Aumentare la shelf life': 'Aumentar la vida útil',
  'Per fermentazioni difficili': 'Para fermentaciones difíciles',
  'Prevenzione e cura dal bret': 'Prevención y tratamiento de brett',
  'Prevenzione e cura ossidazioni': 'Prevención y tratamiento de oxidaciones',
  'Prevenzione e cura riduzioni lieviti Atecnos':
    'Prevención y tratamiento de reducciones de levaduras Atecnos',
  'Produzione acido malico': 'Producción de ácido málico',
  'Proteggere il colore': 'Proteger el color',
  'Arresti fermentativi': 'Paradas de fermentación',
  'Degradazione acido malico': 'Degradación de ácido málico',
  'Per il vigneto': 'Para el viñedo',
  'Proteggere le uve in fase di raccolta':
    'Proteger las uvas durante la cosecha',
  'Raggiungere la stabilità tartarica': 'Lograr la estabilidad tartárica',

  // Tipo de vino
  Bianchi: 'Blancos',
  Rossi: 'Tintos',
  Rosati: 'Rosados',
  Spumantizzati: 'Espumosos',
  'Senza solfiti': 'Sin sulfitos',
  Aromatici: 'Aromáticos',
  Dolci: 'Dulces y de pasas',

  // Certificaciones
  'ICEA Prodotto Biologico': 'ICEA Producto Ecológico',

  // Tipo de Producto
  'Lieviti Saccharomyces': 'Levaduras Saccharomyces',
  'Lieviti non Saccharomyces': 'Levaduras no Saccharomyces',
  'Attivanti secchi': 'Activadores secos',
  'Autolisati in crema Atecnos': 'Autolizados en crema Atecnos',
  'Batteri lattici': 'Bacterias lácticas',
  'Da affinamento': 'Para crianza',
  'In fermentazione': 'En fermentación',
  'In finissaggio': 'En acabado',
  'Per uve e mosti': 'Para uvas y mostos',
  'Schizosaccharomyces pombe': 'Schizosaccharomyces pombe',
  'Super anti-ossidanti': 'Super antioxidantes',

  // Stili Birra
  'English Barleywine': 'English Barleywine',

  'English IPA': 'English IPA',

  'Imperial Stout': 'Imperial Stout',

  'Belgian Pale Ale': 'Belgian Pale Ale',

  'English Brown Ale': 'English Brown Ale',

  'New England IPA': 'New England IPA',

  'Scottish Heavy': 'Scottish Heavy',

  Stout: 'Stout',

  Witbier: 'Witbier',

  'American IPA': 'American IPA',

  'Belgian And French Ale': 'Belgian And French Ale',

  'Belgian Blonde Ale': 'Belgian Blonde Ale',

  'Belgian Dark Strong Ale': 'Belgian Dark Strong Ale',

  'Belgian Strong Ale': 'Belgian Strong Ale',

  'Dry Stout': 'Dry Stout',

  Dubbel: 'Dubbel',

  'English Old Ale': 'English Old Ale',

  'Imperial IPA': 'Imperial IPA',

  'Oatmeal Stout': 'Oatmeal Stout',

  Saison: 'Saison',

  'Scottish Light': 'Scottish Light',

  Tripel: 'Tripel',

  'Vienna Lager': 'Vienna Lager',

  Bock: 'Bock',

  Doppelbock: 'Doppelbock',
  Marzen: 'Marzen',
  'Münchener dunkel': 'Münchener dunkel',
  Oktoberfestbier: 'Oktoberfestbier',
  'Traditional bock': 'Traditional bock',
  Weiss: 'Weiss',
  Pils: 'Pils',
  'Strong English Ale': 'Strong English Ale',
  IPA: 'IPA',
  'Juicy IPA': 'Juicy IPA',
  'Pale ale': 'Pale ale',
  Ale: 'Ale',
  'Amber Lager': 'Amber Lager',
  'American Lager': 'American Lager',
  'Dark Lager': 'Dark Lager',
  Lambic: 'Lambic',
  'Birre speciali': 'Cervezas especiales',
  'Birre speziate': 'Cervezas especiadas',
  'Birre aromatiche': 'Cervezas aromáticas',
  'Rifermentazioni in bottiglia': 'Refermentaciones en botella',
  Porter: 'Porter',
  'Fruit Beer': 'Fruit Beer',
  'American Stout': 'American Stout',
  'American Pale Ale': 'American Pale Ale',
  'American Amber Ale': 'American Amber Ale',
  'American Brown Ale': 'American Brown Ale',
  'American Ale': 'American Ale',
  'American Wheat Ale': 'American Wheat Ale',
  'Berliner Weisse': 'Berliner Weisse',
  'Bière De Garde': 'Bière De Garde',
  'Dusseldorf Altbier': 'Dusseldorf Altbier',
  'German Brown': 'German Brown',
  Kolsch: 'Kolsch',
  'Scottish Heavy': 'Scottish Heavy',
  'Traditional bock': 'Traditional bock',
  'Belgian Dubbel': 'Belgian Dubbel',

  // Fermentazione Birra
  'Alta fermentazione': 'Alta fermentación',
  'Bassa fermentazione': 'Baja fermentación',
}
